import { useThemeStore } from "./themeStore";

export const useTheme = () => {
    const { theme, setTheme, toggleTheme } = useThemeStore();

    return {
        theme,
        setTheme,
        toggleTheme,
        isDark: theme === "dark",
        isLight: theme === "light",
    };
};

